module.exports = __webpack_public_path__ + "ahrefs-1-aebb1d39cedf919e5f0dd660e27a55c5.webp";